import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=3009b8b5&"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js&"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PasswordUpdate.vue?vue&type=style&index=0&id=3009b8b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports